import React, { useCallback, useRef } from "react";

import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import styles from "./CadenceStatusLink.module.scss";

interface Props {
  active?: boolean;
  children: React.ReactNode;
  className?: string;
  onClick?: (element?: HTMLElement) => void;
  type?: "error" | "info" | "warning";
}

const CadenceStatusLink: React.FC<Props> = ({
  active = true,
  children,
  className,
  onClick,
  type,
}) => {
  const ref = useRef<HTMLElement>(null);
  const handleClick = useCallback(() => {
    onClick?.(ref.current ?? undefined);
  }, [ref, onClick]);

  return (
    <span
      className={cn(styles.status, { [styles.active]: active }, type && styles[type], className)}
      onClick={handleClick}
      ref={ref}
    >
      <FontAwesomeIcon icon={faExclamationCircle} />
      {children}
      {active && <FontAwesomeIcon icon={faChevronRight} />}
    </span>
  );
};

export default CadenceStatusLink;
